<div >
    <div class="title-container">
        <div class="left-title">
            <p class="main-left-title">{{this.headerContent.leftContent.title}}</p>
            <p class="sub-left-title">{{this.headerContent.leftContent.subtitle}}</p>
        </div>

        <div class="right-title">
            <p class="main-right-title">{{this.headerContent.rightContent.title}}</p>
            <p class="sub-right-title">{{this.headerContent.rightContent.subtitle}}</p>
        </div>
    </div>
    <div class="divider">
        <mat-divider></mat-divider>
    </div>
</div>
